/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
/* eslint-disable eqeqeq */
import React from 'react';

// ePOD Activity Log - small icon in the Action area, always available (read-only, no eligibility
// gating - unlike Upload/View/Revert POD, viewing history is never conditional on workflow state).
// Opens ViewLogsSlider for this row via the same context.componentParent convention every other
// action button in this grid already uses (see viewpodbutton.js/uploadpodbutton.js).
const ViewLogsButton = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.onClickViewLogs(props.data);
    };

    return (
        <button
            onClick={handleClick}
            className="btn btn-outline-secondary"
            style={{ padding: "2px 8px", fontSize: "13px", margin: "0" }}
            title="View Logs"
        >
            <i className="icofont icofont-eye-alt" aria-hidden="true"></i>
        </button>
    );
};

export default ViewLogsButton;
